export default __webpack_public_path__ + "static/media/iain-lhPNTD2ii0U-unsplash.545d4c62.jpg";